<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-card>
      <v-card-title>Get Park from Money Destination</v-card-title>
      <v-card-title>
        <v-autocomplete
          label="Money Destination from which get the Parks"
          :items="mds"
          v-model="mdToModifyId"
          item-title="visual_name"
          item-value="id"
        />
      </v-card-title>
      <template v-if="assocParks !== null">
        <v-divider/>
        <v-card-text>
          <v-container>
            <v-row>
              <template v-if="assocParks.length > 0">
                <v-col v-for="park in assocParks">
                  <v-card>
                    <v-card-title><b>Park:</b> {{ park['name'] }}</v-card-title>
                    <v-card-title><b>ID:</b> {{ park['id'] }}</v-card-title>
                  </v-card>
                </v-col>
              </template>
              <v-col v-else>
                <p class="text-center"><b>No Associated Park Found</b></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
  </PanelPage>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import PanelPage from "../components/PanelPage.vue";
import { fetchMoneyDests } from "../remote/moneydest.js";
import { fetchCSs, fetchParks } from "../remote/park.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);

const mds = ref([]);
const parks = ref([]);
const mdToModifyId = ref(null);
const assocParks = ref(null);

/*
 Yes I know it's terrible. No, it seems the performance are still ok because you can't do better in JS...
 https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
 */
function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

watch(mdToModifyId, async (newValue) => {
  assocParks.value = null;
  if (newValue !== null) {
    loadingOverlay.value = true;
    const assocCSs = await fetchCSs({ 'money_receiver': newValue });
    const parksIds = assocCSs.map(cs => cs['park']).filter(onlyUnique);
    assocParks.value = parks.value.filter((p) => parksIds.includes(p['id']));
    loadingOverlay.value = false;
  }
});

onMounted(async () => {
  loadingOverlay.value = true;
  // Retrieve MoneyDestinations and Parks
  try {
    [mds.value, parks.value] = await Promise.all([fetchMoneyDests(), fetchParks()]);
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load Money Destinations or Parks', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});

</script>

<style scoped>

</style>
